var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Статус исполнителя в заявке",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      "route-create": "TaskWorkerStatusAdd",
      "route-edit": "TaskWorkerStatusEdit",
      "route-view": "TaskWorkerStatusView",
      "route-path": "/task_worker_statuses",
      "can-edit": _vm.canEditCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68ab37ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68ab37ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/TaskWorkerStatuses/TaskWorkerStatuses.vue
// module id = null
// module chunks = 